import { FormErrors } from 'redux-form';

interface IDpsDeclaration {
  dpsDeclaration: string;
}

export default (values: IDpsDeclaration) => {
  const errors: FormErrors<any> = {};

  if (!values.dpsDeclaration) {
    errors.dpsDeclaration = 'Debe seleccionar alguna opción';
  }

  return errors;
};
